import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  AdminForgetPasswordInputDto,
  AdminGenerateUserOTPInputDto,
  AdminLoginInputDto,
  AdminLoginReturnDtoGeneralResponse,
  AdminNewPasswordInputDto,
  AdminOTPInputDto,
  AdminOTPOutputDtoGeneralResponse,
  SetFundManagerPasswordInputDto,
  StringGeneralResponse,
} from '../data-models/authentication.data.models';
import { EUserType, GeneralResponse } from 'src/app/shared/shared-data-models';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private readonly controllerUrl =
    `${environment.appConfig.adminGatewayServiceBaseUrl}/api/Authentication/`;

  constructor(private readonly baseApiService: BaseApiService<any>) {}

  login(body: AdminLoginInputDto): Observable<AdminLoginReturnDtoGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl}Login`, body);
  }

  setFundManagerPassword(body: SetFundManagerPasswordInputDto): Observable<GeneralResponse<boolean>> {
    return this.baseApiService.Post(`${this.controllerUrl}setFundManagerPassword`, body);
  }

  forgetPassword(body: AdminForgetPasswordInputDto): Observable<StringGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl}ForgetPassword`, body);
  }

  setNewPassword(body: AdminNewPasswordInputDto): Observable<StringGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl}SetNewPassword`, body);
  }

  logout(): Observable<StringGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl}Logout`);
  }

  generateUserOTP(body: AdminGenerateUserOTPInputDto): Observable<StringGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl}GenerateUserOTP`, body);
  }

  validateUserOTP(body: AdminOTPInputDto): Observable<AdminLoginReturnDtoGeneralResponse> {
    return this.baseApiService.Post(`${this.controllerUrl}ValidateUserOTP`, body);
  }

  getUserOTPDev(
    email: string,
    userTypeId?: EUserType
  ): Observable<AdminOTPOutputDtoGeneralResponse> {
    let params = new HttpParams().set('email', email);
    if (userTypeId !== undefined) {
      params = params.set('userTypeId', userTypeId.toString());
    }
    return this.baseApiService.Get(
      `${this.controllerUrl}GetUserOTPDev?${params.toString()}`
    );
  }
}
